<template>
  <div class="gallery">
    <v-heading level="h6">Conheça nossa estrutura</v-heading>
    <swiper ref="swiper" v-if="ready" :options="options">
      <swiper-slide v-for="(image, index) in images" :key="index">
        <span><img :src="image"></span>
      </swiper-slide>
    </swiper>
    <div class="gallery__bottom">
      <button class="prev" ref="prev">
        <i class="icon-arrow" alt="Anterior"></i>
      </button>
      <div class="pagination" ref="pagination"></div>
      <button class="next" ref="next">
        <i class="icon-arrow" alt="Próximo"></i>
      </button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Heading from '@/components/uikit/text/Heading.vue';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
// eslint-disable-next-line
import 'swiper/dist/css/swiper.css';

export default {
  name: 'StructurePhotos',
  components: {
    'v-heading': Heading,
    swiper,
    swiperSlide,
  },
  props: {
    images: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      ready: false,
      options: {
        slidesPerView: 1,
        centeredSlides: true,
        pagination: {
          clickable: true,
          dynamicBullets: true,
        },
      },
    };
  },
  mounted() {
    Vue.set(this.options.pagination, 'el', this.$refs.pagination);
    Vue.set(this.options, 'navigation', {
      prevEl: this.$refs.prev,
      nextEl: this.$refs.next,
    });
    this.ready = true;
  },
};
</script>

<style lang="scss" scoped>
$component: '.gallery';
#{$component} {
  text-align: center;
  h6.heading {
    color: $color-b;
  }
  .swiper-container {
    margin-bottom: $gutter-xl;
  }
  img {
    display: block;
    max-width: 100%;
    margin: auto;
  }
  @include swiper-pagination(#{$component + '__bottom'});
}
</style>
